import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PermissionStore } from 'app/shared/store/permission.store';
import { filter, map, take, tap } from 'rxjs';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const permissionStore = inject(PermissionStore);
  const router = inject(Router);
  const key = route.data['permissionKey'] as string;

  return toObservable(permissionStore.loaded).pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => permissionStore.hasAccess()(key)),
    tap((isAllowed) => {
      if (!isAllowed) {
        router.navigate(['/not-found']).then(() => {});
      }
    })
  );
};
